import {reduxForm, Field} from 'redux-form'
import {connect} from 'react-redux'
import DropdownOutlet from 'components/Fields/ReduxForm/DropdownOutlet'
import DropdownCalendar from 'components/Fields/ReduxForm/DropdownCalendar'
import styles from './ActionBar.css'
import OutletModal from 'components/Fields/ReduxForm/OutletModal'
import MenuTitle from 'components/MenuTitle'
import {isFullSiteMode} from 'utils/fullSite'

class ActionBar extends React.Component {
  render () {
    const {outlets, showModalOutletMobileState} = this.props

    return (
      <div>
        <MenuTitle menuTitle='Sales' />
        { !isFullSiteMode() &&
          <div className='col-md-6 visible-lg visible-md action-sidebar'>
            <a className='pull-right btn btn-primary export-button' onClick={this._onClickExportButton} id={styles.export}>
              Export
            </a>
          </div>
        }
        <div className='mk-action-bar'>
          <div className='row'>
            <div className='col-sm-12 col-md-9'>
              <div className='visible-md visible-lg pull-left mr-5px'>
                <Field
                  component={DropdownOutlet}
                  outlets={outlets}
                  onChangeOutletIds={this._onChangeOutlet}
                  name='outlet'
                  allOutletOption
                />
              </div>
              <div className='pull-left'>
                <Field
                  component={DropdownCalendar}
                  name='date'
                  onChange={this._onChangeDate}
                  updateServerOnChange
                />
              </div>
            </div>
            <Field
              component={OutletModal}
              name='outlet'
              outlets={outlets || []}
              onChangeOutletIds={this._onChangeOutlet}
              allOutletOption
              show={showModalOutletMobileState}
            />
          </div>
        </div>
      </div>
    )
  }

  _onChangeOutlet = (outletIds) => {
    this.props.onChangeOutlet(outletIds)
  };

  _onChangeDate = ({startDate, endDate}) => {
    this.props.onChangeDate({startDate, endDate})
  };

  _onClickExportButton = () => {
    this.props.onExport()
  }
}

const mapForm = {
  form: 'search'
}

function mapStateToProps (state) {
  return {
    outlets: state.reports.sales.outlets,
    showModalOutletMobileState: state.moka.showModalOutletMobile
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

ActionBar.propTypes = {
  onChangeOutlet: React.PropTypes.func,
  onChangeDate: React.PropTypes.func,
  onExport: React.PropTypes.func
}
export default reduxForm(mapForm)(connect(mapStateToProps, mapDispatchToProps)(ActionBar))



// WEBPACK FOOTER //
// ./app/pages/Reports/Sales/ActionBar/ActionBar.js